var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.payment_item[data-v-f7db971a]{color:#b7b0a9;background-color:#262825;border:4px solid transparent;-o-border-image:url(" + escape(require("../../images/frame_payment_item.png")) + ") 4 repeat;border-image:url(" + escape(require("../../images/frame_payment_item.png")) + ") 4 repeat\n}\n", ""]);

// exports
